// Sticky mobile buy bar: shows once its trigger element (the product grid on
// the homepage, the buy block on a product page) scrolls out of view, hides
// once the footer enters the viewport. Tracks the last-tapped size pill;
// defaults to the bundle/current product until the visitor taps one.
(function () {
  var bar = document.querySelector('[data-candells-section="sticky-buy-bar"]');
  if (!bar) return;

  var trigger = document.querySelector('[data-candells-sticky-trigger]');
  var footer = document.querySelector('.footer');

  var triggerPassed = false;
  var footerReached = false;

  function sync() {
    bar.hidden = !triggerPassed || footerReached;
  }

  if (trigger && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      triggerPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sync();
    }).observe(trigger);
  }

  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      footerReached = entries[0].isIntersecting;
      sync();
    }).observe(footer);
  }

  var titleEl = bar.querySelector('[data-candells-sticky-title]');
  var metaEl = bar.querySelector('[data-candells-sticky-meta]');
  var imageEl = bar.querySelector('[data-candells-sticky-image]');
  var urlEl = bar.querySelector('[data-candells-sticky-url]');
  var variantInput = bar.querySelector('[data-candells-sticky-variant-input]');

  document.addEventListener('candells:variant:picked', function (event) {
    var detail = event.detail || {};
    if (titleEl) titleEl.textContent = detail.title || bar.dataset.defaultTitle;
    if (metaEl) metaEl.textContent = (detail.size || '') + ' · ' + (detail.price || '');
    if (imageEl && detail.image) imageEl.src = detail.image;
    if (urlEl && detail.url) urlEl.href = detail.url;
    if (variantInput && detail.variantId) variantInput.value = detail.variantId;
  });
})();
